// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"a1be2c45","453":"5783c3fe","993":"f24e92fe"}[chunkId] + ".chunk.js";
};